import type { CameraViewPreset } from '../types';

/** Selection is camera-driving only in the explicit Focus preset. */
export function shouldReframeCameraOnSelection(preset: CameraViewPreset): boolean {
  return preset === 'focus';
}

